<p-dialog
    [header]="l('::ChangeCurrentPlace')"
    [modal]="true"
    [(visible)]="isVisible"
    [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
    
    @for (place of placesItems; track place.id) {
        <div class="row mb-2">
            <div class="col">
                <p-fluid>
                    <p-button
                        [label]="place.name"
                        [icon]="place.id === currentPlace?.id ? 'fas fa-map-marker-alt' : ''"
                        (onClick)="updatePlace(place)"
                        [outlined]="place.id !== currentPlace?.id"
                        style="font-size: large;">
                    </p-button>
                </p-fluid>
            </div>
        </div>
    }
</p-dialog>